import LoadingCircle from "../../components/LoadingCircle";

export default class PasswordReset {


    constructor() {
        this.changePasswordBtn = $('#submit_button')
        this.resetPasswordForm = $('#reset-password-form')

        this.emailField = $('#email')

        this.events()
    }

    events() {
        // this.changePasswordBtn.on('click', e => this.changePassword(e))
        this.resetPasswordForm.on('submit', e => this.emailValidation(e))
        // this.emailField.on('change', e => {
        //     $('#invalid-email-reset-inner').remove();
        // })
    }

    emailValidation(e){

        this.loadingCircle = new LoadingCircle()
        let email_input = $('#email').val();
        let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
        $('#invalid-email-reset-inner').remove();
        $('.invalid-feedback span').remove();

        if(!email_input){
            e.preventDefault();
            $("#invalid-email-reset").append("<div id='invalid-email-reset-inner'>⚠ Email address is required</div>");
            return false;
        }

        if((emailReg.test(email_input)) == true){
            this.loadingCircle.buttonShow(this.changePasswordBtn)
            return true;
        }else{
            e.preventDefault();
            $("#invalid-email-reset").append("<div id='invalid-email-reset-inner'>⚠ Please input a valid Email Address eg: johndoe@mail.co</div>");
            return false;
        }

    }

}